import type { FC, ReactNode, SyntheticEvent } from "react";

import { Container, Tab, Tabs } from "@mui/material";
import { styles } from "@repo/helpers";
import { useState } from "react";

export interface NavigationSplitViewTab {
	id: string | number;
	tab: ReactNode;
	detail: ReactNode;
}

interface NavigationSplitViewProps {
	id?: string;
	tabs: NavigationSplitViewTab[];
	className?: string;
	scrollable?: boolean;
}

export const NavigationSplitView: FC<NavigationSplitViewProps> = ({ id, tabs, className, scrollable }) => {
	const [value, setValue] = useState<string | number>(tabs[0].id);

	const handleChange = (event: SyntheticEvent, newValue: string) => {
		setValue(newValue);
	};

	return (
		<div className={styles("flex flex-row py-4", className)}>
			<Tabs
				id={id}
				value={value}
				onChange={handleChange}
				orientation="vertical"
				variant={scrollable ? "scrollable" : "standard"}
				scrollButtons={scrollable}
				allowScrollButtonsMobile={scrollable}
				sx={{
					".MuiTabs-scrollButtons.Mui-disabled": {
						opacity: 0.3,
					},
				}}
			>
				{tabs.map((t) => (
					<Tab key={t.id} value={t.id} label={t.tab} sx={{ textAlign: "left" }} />
				))}
			</Tabs>
			<Container className="container">{value && tabs.find((t) => t.id === value)?.detail}</Container>
		</div>
	);
};
